// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_22-3";
export var dialog = "_22-0";
export var divClassnameSwatch = "_22-8";
export var flexSwatch = "_22-4";
export var header = "_22-1";
export var styleAttributeSwatch = "_22-7";
export var swatch = "_22-2";
export var textHeaderSwatch = "_22-5";
export var webSwatch = "_22-6";